
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evm/welcome",
      function () {
        return require("private-next-pages/evm/welcome/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evm/welcome"])
      });
    }
  